<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 渠道渠道
                </el-breadcrumb-item>
                <el-breadcrumb-item>渠道管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >
            <el-collapse accordion style="padding:0px 30px 10px 0px;background-color:#fff; margin-top:-20px">
                <el-collapse-item>
                    <template slot="title">
                        <div  style="font-size:18px;"> <i class="header-icon el-icon-info" style="color:#F56C6C;margin-right:10px;"></i>操作说明</div>
                    </template>
                    <div style="font-size:14px;color:#333;"> <pre>
        1.渠道标识命名规则：以区域开头+公司名称小写拼音  如河南电信，渠道标识为 henandianxin  如广州银象，渠道标识为 gaungzhouyinxiang
        2.上游回调URL 规则：以 http://cl.yxwl1688.cn/callback/ + 渠道标识 ，如河南电信为 http://cl.yxwl1688.cn/callback/henandianxin
        3.禁用: 禁用渠道，该渠道已添加商品自动重新下架，不能进行提单
        4.启用：启用渠道，该渠道已添加商品可以再次提交 </pre>

                    </div> 
                </el-collapse-item>
            </el-collapse> 
               
                <span class="label-span">
                    <label class="label">渠道名称</label>
                    <el-input v-model.trim="query.name" placeholder="渠道名称" class="handle-input mr15"></el-input>
                </span>
                <span class="label-span">
                    <label class="label">渠道类型</label>
                    <el-select v-model="query.ctype"  placeholder="渠道状态" clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span>   
                <span class="label-span">
                    <label class="label">渠道状态</label>
                    <el-select v-model="query.status"  placeholder="渠道状态" clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option value="1" label="开启"  /> 
                        <el-option value="0" label="禁用"  /> 
                    </el-select>
                </span>   
                <span class="label-span">
                    <label class="label">订购通知</label> 
                    <el-select v-model="query.notifyType"  placeholder="订购通知" clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option value="1" label="上游回调"  /> 
                        <el-option value="2" label="接口查询"  /> 
                    </el-select>
                </span>   
                <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10"  @click="refreshSearch">重置</el-button>
                <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10"  @click="addBind" >新增渠道</el-button>
               
               
          </el-card>
          <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>-->
                <el-table-column prop="id" width="70" align="center" label="渠道ID"></el-table-column>
                <el-table-column prop="name" min-width="160" align="left" label="渠道名称"> </el-table-column>
                <el-table-column prop="uid" min-width="160" align="left" label="关联员工">
                    <template slot-scope="scope" >
                    <span v-for="item in select1.option" v-if='scope.row.uid==item.optKey'>
                        {{item.optVal}}
                    </span>
                    </template>
                </el-table-column>
                <el-table-column prop="perRatio" min-width="160" align="left" label="分成比例">
                    <template slot-scope="scope" >
                        {{scope.row.perRatio}}%
                    </template>
                </el-table-column>
                <el-table-column prop="cname" min-width="100" align="center" label="渠道类型"></el-table-column>
                <el-table-column prop="fag" min-width="120" align="left" label="渠道标识"> </el-table-column>
                <el-table-column prop="status" min-width="80" align="center" label="订购结果">
                      <template slot-scope="scope" >   
                        {{scope.row.notifyType==1?'上游回调':'接口查询'}}
                    </template> 
                </el-table-column> 
                <el-table-column prop="status" min-width="80" align="center" label="渠道状态">
                      <template slot-scope="scope" >   
                        <el-tooltip :content="scope.row.status=='1'?'渠道已开启':'渠道已关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template> 
                </el-table-column> 
                <!-- <el-table-column prop="aesId" width="80" align="center" label="轮询">
                      <template slot-scope="scope" >   
                        <el-tooltip :content="scope.row.task=='1'?'轮询已开启':'轮询已关闭'" placement="top">
                            <el-switch @change="task(scope.$index, scope.row)"
                                v-model="scope.row.task"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template> 
                </el-table-column>    
                <el-table-column prop="goodsNum" min-width="180" align="left" label="产品数据">
                    <template slot-scope="scope" >
                        所有产品：{{scope.row.goodsAllNum}} <br>
                        上架产品：{{scope.row.goodsAllOnNum}} <el-tag >{{parseFloat(scope.row.goodsAllOnNum*100/scope.row.goodsAllNum).toFixed(2)}}%</el-tag><br>
                        渠道产品：{{scope.row.goodsNum}} <el-tag >{{parseFloat(scope.row.goodsNum*100/scope.row.goodsAllNum).toFixed(2)}}%</el-tag><br>
                        渠道上架：{{scope.row.goodsOnNum}} <el-tag >{{parseFloat(scope.row.goodsOnNum*100/scope.row.goodsAllOnNum).toFixed(2)}}%</el-tag> <br>
                    </template> 
                </el-table-column> 
                <el-table-column prop="goodsNum" min-width="180" align="left" label="订单数据数据">
                    <template slot-scope="scope" >
                        渠道订单{{scope.row.channelOrder}} <br>
                        通过订单{{scope.row.crossOrder}} <el-tag v-if="scope.row.channelOrder && scope.row.channelOrder!='0'">{{parseFloat(scope.row.crossOrder*100/scope.row.channelOrder).toFixed(2)}}%</el-tag><br>
                        激活订单{{scope.row.activeOrder}} <el-tag  v-if="scope.row.channelOrder && scope.row.channelOrder!='0'">{{parseFloat(scope.row.activeOrder*100/scope.row.channelOrder).toFixed(2)}}%</el-tag> <br>
                        结算订单{{scope.row.cashOrder}} <el-tag  v-if="scope.row.channelOrder && scope.row.channelOrder!='0'">{{parseFloat(scope.row.cashOrder*100/scope.row.channelOrder).toFixed(2)}}%</el-tag> 
                    </template> 
                </el-table-column>    -->

                <el-table-column prop="createTime" min-width="165" align="center"  label="创建时间"> </el-table-column>  
                <el-table-column label="操作" min-width="180" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card> 
        <!-- 新建自主渠道弹出框 -->
        <el-dialog :close-on-click-modal="false" title="新增渠道" :visible.sync="addVisible" :modal-append-to-body='false' top="50px" width="680px">
            <el-form ref="form1" :model="form1" label-width="110px" @submit.native.prevent="saveForm">
                <el-form-item label="渠道名称" required style="width:50%;display:inline-block;margin-top:-25px;">
                    <el-input v-model.trim="form1.name"  placeholder="渠道名称" style="width:100%" ></el-input>
                </el-form-item>  
                <el-form-item label="渠道类型" required style="width:50%;display:inline-block;margin-top:-25px;">
                    <el-select  v-model.trim="form1.ctype"  placeholder="渠道分类" style="width:100%" >
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </el-form-item>
                <el-form-item label="关联员工" required style="width:50%;display:inline-block;"  >
                    <el-select v-model.trim="form1.uid"  placeholder="选择员工"   filterable clearable  @change="value=>uidChange(form1,value)">
                        <el-option v-for="item in select1.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
                <el-form-item label="分成比例" required style="width:50%;display:inline-block;margin-top:-25px;">
                    <el-input  v-model.trim="form1.perRatio" placeholder="请输入0-99的正整数" :disabled="isCompanyManagement(form1.uid)"
                               oninput ="value=value.replace(/[^\d]/g,''); if(value.length>2) value=value.slice(0,2)" >
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="渠道标识" required style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form1.fag"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数1" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form1.fb1"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数2" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form1.fb2"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数3" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form1.fb3"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数4" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form1.fb4"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="渠道 ID" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form1.appId"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="对接密钥" style="width:100%;margin-top:-10px;" >
                    <el-input  v-model.trim="form1.appKey"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="用户校验URL"  style="margin-top:-10px;">
                    <el-input  v-model.trim="form1.checkUserUrl"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="发送短验URL" required style="margin-top:-10px;">
                    <el-input v-model.trim="form1.sendSmsUrl"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="提交短验URL" required style="margin-top:-10px;" >
                    <el-input v-model.trim="form1.submitSmsUrl"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="订购结果通知" required style=" margin-top:-10px" >
                    <el-radio-group  v-model.trim="form1.notifyType" >
                        <el-radio-button label="1">上游回调</el-radio-button> 
                        <el-radio-button label="2">接口查询</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>  
                <el-form-item v-if="form1.notifyType==2" label="接口查询URL" style=" margin-top:-10px">
                    <el-input v-model.trim="form1.queryOrderUrl"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item v-if="form1.notifyType==2" label="延后查询" style=" margin-top:-10px">
                    <el-input v-model.trim="form1.queryTime"   style="width:80%" oninput="value=value.replace(/[^0-9.]/g,'')" ></el-input> 分钟
                </el-form-item>
                 <el-form-item v-if="form1.notifyType==1" label="上游回调URL" style=" margin-top:-10px">
                    <el-input v-model.trim="form1.callbackUrl"   style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="其他URL" style=" margin-top:-10px" >
                    <el-input v-model.trim="form1.otherUrl"   style="width:100%"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
         
  

        <!-- 编辑自主渠道弹出框 -->
        <el-dialog :close-on-click-modal="false" title="编辑渠道" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="680px">
            <el-form ref="form2" :model="form2" label-width="120px">
                <el-form-item label="渠道名称" style="width:50%;display:inline-block;margin-top:-25px;">
                    <el-input v-model.trim="form2.name"  placeholder="渠道名称" style="width:100%" ></el-input>
                </el-form-item>  
                <el-form-item label="渠道类型" style="width:50%;display:inline-block;margin-top:-25px;">
                    <el-select  v-model.trim="form2.ctype"  placeholder="渠道分类" style="width:100%" >
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </el-form-item>
                <el-form-item label="关联员工" style="width:50%;display:inline-block;"  >
                    <el-select v-model.trim="form2.uid"  placeholder="选择员工"   filterable clearable @change="value=>uidChange(form2,value)" >
                        <el-option v-for="item in select1.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
                <el-form-item label="分成比例" style="width:50%;display:inline-block;margin-top:-25px;">
                    <el-input  v-model.trim="form2.perRatio" placeholder="请输入0-99的正整数" :disabled="isCompanyManagement(form2.uid)"
                               oninput ="value=value.replace(/[^\d]/g,''); if(value.length>2) value=value.slice(0,2)" >
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="渠道标识" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form2.fag"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数1" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form2.fb1"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数2" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form2.fb2"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数3" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form2.fb3"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数4" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form2.fb4"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="渠道 ID" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form2.appId"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="对接密钥" style="width:100%;margin-top:-10px;" >
                    <el-input  v-model.trim="form2.appKey"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="用户校验URL"  style="margin-top:-10px;">
                    <el-input  v-model.trim="form2.checkUserUrl"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="发送短验URL" style="margin-top:-10px;">
                    <el-input v-model.trim="form2.sendSmsUrl"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="提交短验URL" style="margin-top:-10px;" >
                    <el-input v-model.trim="form2.submitSmsUrl"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="订购结果通知"  style=" margin-top:-10px" >
                    <el-radio-group  v-model.trim="form2.notifyType" >
                        <el-radio-button label="1">上游回调</el-radio-button> 
                        <el-radio-button label="2">接口查询</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>  
                <el-form-item v-if="form2.notifyType==2" label="接口查询URL" style=" margin-top:-10px">
                    <el-input v-model.trim="form2.queryOrderUrl"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item v-if="form2.notifyType==2" label="延后查询" style=" margin-top:-10px">
                    <el-input v-model.trim="form2.queryTime"   style="width:80%" oninput="value=value.replace(/[^0-9.]/g,'')" ></el-input> 分钟
                </el-form-item>
                 <el-form-item v-if="form2.notifyType==1" label="上游回调URL" style=" margin-top:-10px">
                    <el-input v-model.trim="form2.callbackUrl"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="其他URL" style=" margin-top:-10px" >
                    <el-input v-model.trim="form2.otherUrl"   style="width:100%"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
          
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus,fetchDataDir} from './channel';
import {fetchSelect} from '../../api/channelType';
import { fetchSelect as fetchSelect1, fetchUserById } from '../user/comUser';
import { isCompanyManagement } from '@/utils/userConfig';  //用户
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            select1:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                notifyType:'1'
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getSelect();
        this.getSelect1();
        this.getData();
    },

    methods: {
        isCompanyManagement,
        getSelect(){
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data; 
                }
            });
        },
        getSelect1(){
            fetchSelect1({'perCodeS':'UpBusiness,CompanyManagement'}).then(res => {
                if(res.code=='200'){
                    this.$set(this.select1, 'option', res.data);
                }
            });
        },
        uidChange(form,value){
            if (!value || isCompanyManagement(value)){
                this.$set(form,"perRatio","0");
                return;
            }
            this.getUser(value,user=>{
                this.$set(form,"perRatio",user.pnum);
            });
        },
        getUser(userId,fun){
            fetchUserById({id:userId}).then(res=>{
                if (res.code == '200') {
                    let user = res.data;
                    if (fun){
                        fun(user);
                    }
                }
            })
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'name', '');  
            this.$set(this.query, 'ctype');  
            this.$set(this.query, 'status');    
            this.handleSearch();
        }, 
    

        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 

        //查询
        getData(){  
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        

        // 新增渠道
        addBind() {
            this.getSelect();
            this.addVisible = true; 
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.name ){
                this.isSubmitting = false;
                this.$message.error("请填写渠道名称");
                return;
            }
            if( !this.form1.fag ){
                this.isSubmitting = false;
                this.$message.error("请填写渠道类型");
                return;
            }
            if( !this.form1.uid ){
                this.isSubmitting = false;
                this.$message.error("请选择关联员工");
                return;
            }
            if( !this.form1.perRatio ){
                this.isSubmitting = false;
                this.$message.error("请填写分成比例");
                return;
            }
            this.addVisible = false;  
            this.loading = true; 
            saveForm(this.form1).then(res => {
                this.loading = false; 
                this.isSubmitting = false;
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.refreshSearch(); 
                }else{
                    this.addVisible = true;
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {      
            this.getSelect();
            this.editVisible = true;
            this.form2 = row; 
        },
 
        
        // 保存更改
        saveEdit() {   
            this.editVisible = false;
            changeForm(this.form2).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.editVisible = true; 
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                row.status='1';
                tips = "禁用";
                content = "该渠道已添加商品将全部下架，确定禁用吗？";
            }else{ 
                row.status = '0';
                tips = "启用";
                content = "启用该渠道前请确保渠道已对接成功？需要启用吗？";
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        if(row.status=='0'){ 
                            row.status='1' 
                        }else{ 
                            row.status='0' 
                        }
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('该渠道所有商品将删除，是否要删除？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该渠道商品仍有订单未结算，请手动结算订单！");
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
